import LabelProvider from "core/components/label/LabelProvider";

/**
 * Label provider for learning
 * Summary panel
 */
export default LabelProvider.create({
	YTDCompletions: {
		k: "summary.ytd.completions",
		v: "YTD Completions"
	},

	TotalCompletions: {
		k: "summary.total.completions",
		v: "Total Completions"
	},
	YTDCredits: {
		k: "summary.ytd.credits",
		v: "YTD Credits"
	},
	TotalCredits: {
		k: "summary.total.credits",
		v: "Total Credits"
	},
	SummaryEmpty: {
		k: "summary.empty.title",
		v: "No Summary Found"
	},
	DescriptionEmpty: {
		k: "summary.empty.description",
		v: ""
	}
});



// WEBPACK FOOTER //
// ./src/panels/learningSummary/LearningSummary.labels.ts